export default __webpack_public_path__ + "static/media/classic01.78782aa0.png";